import { c as _c } from "react/compiler-runtime";
import { IconProps } from '../types';
export function InactiveTagIcon(t0) {
  const $ = _c(19);
  const {
    width: t1,
    height: t2,
    fill: t3
  } = t0;
  const width = t1 === undefined ? 65 : t1;
  const height = t2 === undefined ? 71 : t2;
  const fill = t3 === undefined ? "currentColor" : t3;
  let t4;
  let t5;
  if ($[0] !== fill) {
    t4 = <path d="M44.8 32.4C44.8 41.7 32.4 51 32.4 51C32.4 51 20 41.7 20 32.4C20 29.1113 21.3064 25.9573 23.6319 23.6319C25.9573 21.3064 29.1113 20 32.4 20C35.6887 20 38.8427 21.3064 41.1681 23.6319C43.4936 25.9573 44.8 29.1113 44.8 32.4Z" fill={fill} />;
    t5 = <path d="M32.4 37.05C34.9681 37.05 37.05 34.9681 37.05 32.4C37.05 29.8319 34.9681 27.75 32.4 27.75C29.8319 27.75 27.75 29.8319 27.75 32.4C27.75 34.9681 29.8319 37.05 32.4 37.05Z" fill={fill} />;
    $[0] = fill;
    $[1] = t4;
    $[2] = t5;
  } else {
    t4 = $[1];
    t5 = $[2];
  }
  let t10;
  let t11;
  let t12;
  let t13;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <path d="M31.4151 35.0732C31.9622 34.5262 32.8499 34.5262 33.397 35.0732C33.944 35.6203 33.944 36.5081 33.397 37.0552C32.8499 37.6022 31.9622 37.6021 31.4151 37.0552C30.8681 36.5081 30.868 35.6203 31.4151 35.0732Z" fill="white" />;
    t7 = <path d="M30.8108 31.592C30.7341 31.6193 30.6577 31.648 30.5823 31.6792C30.0058 31.918 29.4818 32.2692 29.0406 32.7104C28.8428 32.9079 28.522 32.9078 28.3243 32.7104C28.1265 32.5126 28.1265 32.1912 28.3243 31.9934C28.8181 31.4996 29.3978 31.1013 30.0337 30.8149L30.8108 31.592Z" fill="white" />;
    t8 = <path d="M33.3084 30.3777C33.7528 30.4485 34.1885 30.5709 34.6062 30.7439C35.3056 31.0336 35.9416 31.4582 36.4768 31.9934C36.6745 32.1912 36.6746 32.5127 36.4768 32.7104C36.279 32.9079 35.9582 32.9073 35.7605 32.7097C35.5484 32.4976 35.3169 32.3068 35.0699 32.1392L33.3084 30.3777Z" fill="white" />;
    t9 = <path d="M33.2688 31.3987C32.9832 31.3455 32.6928 31.3181 32.4009 31.3181C32.1509 31.3181 31.9019 31.3378 31.656 31.3767L30.8094 30.53C31.2554 30.4018 31.7157 30.3281 32.1805 30.3103L33.2688 31.3987Z" fill="white" />;
    t10 = <path d="M27.9676 28.7488C27.3169 29.1284 26.7154 29.5893 26.1805 30.1243C25.9827 30.322 25.6619 30.3219 25.4641 30.1243C25.2665 29.9265 25.2664 29.6057 25.4641 29.408C25.9978 28.8743 26.5902 28.4058 27.2285 28.0098L27.9676 28.7488Z" fill="white" />;
    t11 = <path d="M32.4009 26.5347C33.689 26.5347 34.9646 26.7888 36.1546 27.2817C37.3445 27.7747 38.4261 28.4972 39.3369 29.408C39.5346 29.6057 39.5346 29.9265 39.3369 30.1243C39.1392 30.322 38.8184 30.3219 38.6206 30.1243C37.8039 29.3076 36.8342 28.6598 35.7671 28.2178C34.7 27.7757 33.556 27.5484 32.4009 27.5483C31.813 27.5483 31.2277 27.6073 30.6541 27.7234L29.8125 26.8818C30.6541 26.6516 31.5249 26.5346 32.4009 26.5347Z" fill="white" />;
    t12 = <path d="M29.8096 27.9394C29.5474 28.0202 29.2883 28.1124 29.034 28.2178C28.9085 28.2698 28.7839 28.3242 28.6612 28.3818L27.9053 27.626C28.1471 27.5013 28.3944 27.3862 28.6465 27.2817C28.7668 27.2319 28.8879 27.1846 29.0098 27.1396L29.8096 27.9394Z" fill="white" />;
    t13 = <path d="M25.2526 24.1778C25.4723 23.9581 25.8284 23.9581 26.0481 24.1778L39.5481 37.6778C39.7677 37.8975 39.7677 38.2536 39.5481 38.4732C39.3284 38.6929 38.9723 38.6929 38.7526 38.4732L25.2526 24.9732C25.033 24.7536 25.033 24.3975 25.2526 24.1778Z" fill="white" />;
    $[3] = t10;
    $[4] = t11;
    $[5] = t12;
    $[6] = t13;
    $[7] = t6;
    $[8] = t7;
    $[9] = t8;
    $[10] = t9;
  } else {
    t10 = $[3];
    t11 = $[4];
    t12 = $[5];
    t13 = $[6];
    t6 = $[7];
    t7 = $[8];
    t8 = $[9];
    t9 = $[10];
  }
  let t14;
  if ($[11] !== t4 || $[12] !== t5) {
    t14 = <g filter="url(#filter0_d_4961_10669)">{t4}{t5}{t6}{t7}{t8}{t9}{t10}{t11}{t12}{t13}</g>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t14;
  } else {
    t14 = $[13];
  }
  let t15;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <defs><filter id="filter0_d_4961_10669" x="0" y="0" width="65" height="71" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB"><feFlood floodOpacity="0" result="BackgroundImageFix" /><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" /><feOffset /><feGaussianBlur stdDeviation="10" /><feComposite in2="hardAlpha" operator="out" /><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" /><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4961_10669" /><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4961_10669" result="shape" /></filter></defs>;
    $[14] = t15;
  } else {
    t15 = $[14];
  }
  let t16;
  if ($[15] !== height || $[16] !== t14 || $[17] !== width) {
    t16 = <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 65 71" fill="none">{t14}{t15}</svg>;
    $[15] = height;
    $[16] = t14;
    $[17] = width;
    $[18] = t16;
  } else {
    t16 = $[18];
  }
  return t16;
}